export namespace NBackInStockModal {
    export const ID = 'back-in-stock-modal';
}
